/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserTournamentTeam
 */
export interface UserTournamentTeam {
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTeam
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTeam
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentTeam
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentTeam
     */
    memberCount: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentTeam
     */
    wins: number;
    /**
     * 
     * @type {number}
     * @memberof UserTournamentTeam
     */
    losses: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserTournamentTeam
     */
    isManager: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTeam
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserTournamentTeam
     */
    tournamentName?: string;
}

/**
 * Check if a given object implements the UserTournamentTeam interface.
 */
export function instanceOfUserTournamentTeam(value: object): value is UserTournamentTeam {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('memberCount' in value) || value['memberCount'] === undefined) return false;
    if (!('wins' in value) || value['wins'] === undefined) return false;
    if (!('losses' in value) || value['losses'] === undefined) return false;
    if (!('isManager' in value) || value['isManager'] === undefined) return false;
    return true;
}

export function UserTournamentTeamFromJSON(json: any): UserTournamentTeam {
    return UserTournamentTeamFromJSONTyped(json, false);
}

export function UserTournamentTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTournamentTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'size': json['size'],
        'memberCount': json['memberCount'],
        'wins': json['wins'],
        'losses': json['losses'],
        'isManager': json['isManager'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'tournamentName': json['tournamentName'] == null ? undefined : json['tournamentName'],
    };
}

export function UserTournamentTeamToJSON(json: any): UserTournamentTeam {
    return UserTournamentTeamToJSONTyped(json, false);
}

export function UserTournamentTeamToJSONTyped(value?: UserTournamentTeam | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'size': value['size'],
        'memberCount': value['memberCount'],
        'wins': value['wins'],
        'losses': value['losses'],
        'isManager': value['isManager'],
        'tournamentId': value['tournamentId'],
        'tournamentName': value['tournamentName'],
    };
}

